import { Tab } from '@starsoft/common/src/components/Tabs/Tab/props';
import { GameDetailsTabsOptions } from './props';

export const gameDetailsTabsOptions: Array<Tab<GameDetailsTabsOptions>> = [
  {
    label: 'high_win_label',
    value: GameDetailsTabsOptions.HighWin,
  },
  {
    label: 'lucky_win_label',
    value: GameDetailsTabsOptions.LuckyWin,
  },
  {
    label: 'game_description_label',
    value: GameDetailsTabsOptions.Description,
  },
  // {
  //   label: 'review_label',
  //   value: GameDetailsTabsOptions.Review,
  // },
];
